import { render, staticRenderFns } from "./MediasoupAudioConsumer.vue?vue&type=template&id=b8ae8d7a&"
import script from "./MediasoupAudioConsumer.vue?vue&type=script&lang=ts&"
export * from "./MediasoupAudioConsumer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports